import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var useKeyPress = function useKeyPress(targetKey, isFocused) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    keyPressed = _useState2[0],
    setKeyPressed = _useState2[1];
  var downHandler = function downHandler(e) {
    if (e.key === targetKey) {
      e.preventDefault();
      setKeyPressed(true);
    }
  };
  var upHandler = function upHandler(e) {
    if (e.key === targetKey) {
      e.preventDefault();
      setKeyPressed(false);
    }
  };
  useEffect(function () {
    if (targetKey === 'Enter' && isFocused || targetKey !== 'Enter') {
      window.addEventListener('keydown', downHandler);
      window.addEventListener('keyup', upHandler);
      return function () {
        window.removeEventListener('keydown', downHandler);
        window.removeEventListener('keyup', upHandler);
      };
    }
    return function () {};
  }, [isFocused, targetKey]);
  return keyPressed;
};

export { useKeyPress as default };
